import React from "react";
import "./SearchButton.css";

function SearchButton({ fetchApiData, markerPosition }) {
  return (
    <button onClick={fetchApiData} className="search-button">
      Search likely access
      {markerPosition && (
        <div>
          Lat: {markerPosition[0].toFixed(3)}, Lon: {markerPosition[1].toFixed(3)}
        </div>
      )}
    </button>
  );
}

export default SearchButton;
